import { render } from "./Number.vue?vue&type=template&id=828b61c4"
import script from "./Number.vue?vue&type=script&lang=ts"
export * from "./Number.vue?vue&type=script&lang=ts"
script.render = render

export default script